<template>
    <v-container class="fill-height">
        <v-layout wrap class="flex-column">
            <v-row no-gutters>
                <v-col cols="12">
                    <p class="my-3 pt-5 scan-header">ADD/EDIT SCENARIO SCAN</p>
                </v-col>
                <v-col cols="12" v-if="getLoadingStatus && isAdmin">
                    <div class="d-flex align-center justify-center">
                        <Spinner />
                    </div>
                </v-col>
            </v-row>
            <v-row v-if="!getLoadingStatus">
                <v-col cols="12">
                    <Confirm :dialog="dialog" confirmMsg="Are you sure you want cancel?" showCancelBtn confirmBody="All changes will be lost." @hide-confirm="handleConfirm"/>
                    <Confirm :dialog="saveError"
                             confirmMsg="Fill in required fields!"
                             confirmBody="Please fill in all required fields properly before saving scan."
                             @hide-confirm="handleSaveError"
                            :showCancelBtn="false"/>
                </v-col>
                <v-col cols="12">
                    <v-form
                            ref="form"
                            v-model="valid"
                            lazy-validation
                    >
                    <v-col cols="12" class="px-0">
                        <DetailForm
                            :url="url"
                            :path="path"
                            :page="page"
                            :consentType="consent_type"
                            :defaultDelay="default_delay"
                            :scanFrequency="scan_frequency"
                            class="elevation-3"
                            :errorMessages="errorMessages"
                            @set-url="setUrl"
                            @set-path="setPath"
                            @set-consent-type="setConsentType"
                            @set-page="setPage"
                            @set-default-delay="setDefaultDelay"
                            @set-scan-frequency="setScanFrequency"
                        />
                    </v-col>
                    <v-col cols="12" class="my-3 px-0">
                        <ProxiesForm
                            class="elevation-3"
                            :proxy="proxy"
                            @delete-proxy-item="deleteItem"
                            @add-proxy-item="addItem"
                            @set-proxy-region-residential="setResidential"
                        />
                    </v-col>
                    <v-col cols="12" class="my-3 px-0">
                        <ScenarioForm
                            class="elevation-3"
                            :errorMessages="errorMessages"
                            :scenarioList="scenarioList"
                            :consentType="consent_type"
                            @updated="updatedScenario"
                            @remove-scenario="removeScenario"
                            @add-scenario="addScenario"
                        />
                    </v-col>
                    <v-layout wrap align-center justify-center class="mt-5">
                        <Button
                                width="248"
                                depressed
                                v-on:onClick="onCancel"
                                class="ma-3"
                                content="CANCEL"
                                :outlined="true"
                        />
                        <Button
                                width="248"
                                depressed
                                :disabled="false"
                                v-on:onClick="handleSave(true)"
                                class="ma-3"
                                content="SAVE"
                        />
                        <Button
                                v-if="$route.params.scanId"
                                width="248"
                                depressed
                                :disabled="false"
                                v-on:onClick="handleSave(false)"
                                class="ma-3"
                                content="SAVE AS NEW"
                        />
                    </v-layout>
                        </v-form>
                </v-col>
            </v-row>
        </v-layout>
    </v-container>
</template>

<script>
    import ScenarioForm from "../components/form/ScenarioScan/ScenarioForm";
    import ProxiesForm from "../components/form/ScenarioScan/ProxiesForm";
    import DetailForm from "../components/form/ScenarioScan/DetailForm";
    import Button from "../components/common/Button";
    import Confirm from "../components/common/Confirm";
    import { createNamespacedHelpers, mapGetters } from "vuex";
    import asyncDataStatus from "../mixins/asyncDataStatus";
    import Spinner from "../components/common/Spinner";
    import { ValidationMixin } from "../mixins";
    import {
        frequencyErrors,
        integerErrors,
        requiredErrors,
        requiredUserAgent
    } from "../helper/errorMessage";
    import { SCAN_LIST } from "../utils/routes";
    const formHelper = createNamespacedHelpers("form");
    const authHelper = createNamespacedHelpers("auth");
    import formApi from "../api/form";
    export default {
        name: "ScenarioScan",
        components: { DetailForm, ProxiesForm, ScenarioForm, Button, Spinner, Confirm },
        mixins: [asyncDataStatus, ValidationMixin],
        data() {
            return {
                scanId: '',
                url: {},
                path: '',
                scan_frequency: 6,
                default_delay: 30,
                consent_type:{},
                page: {},
                proxy: [{
                    tool: null,
                    region: null,
                    residential: false,
                    isResidentialEnable: true
                }],
                scenarioList:[],
                dialog: false,
                saveError: false,
                valid: true,
            };
        },
        computed: {
            ...mapGetters(["getLoadingStatus"]),
            ...authHelper.mapGetters(["getSelectedClient", "isAdmin", "getSelectedClientName"]),
            ...formHelper.mapGetters(["getProxyToolsList", "getScenarioScanData", "getWebsitesList"]),
            errorMessages() {
                return {
                    requiredErrors,
                    integerErrors,
                    frequencyErrors,
                    requiredUserAgent
                };
            }
        },
        methods: {
            ...formHelper.mapActions(["fetchFormAllSelectBoxData","createScenarioScan", "fetchScenarioScanByScanId"]),

            async loadFormAllSelectBoxData() {
                try {
                    await this.loadingStart();
                    this.$route.params.scanId && (this.scanId = this.$route.params.scanId) &&
                    (await this.fetchScenarioScanByScanId(this.$route.params.scanId));
                    await this.fetchFormAllSelectBoxData(this.getSelectedClient);
                    await this.loadingEnd();
                } catch (e) {
                    window.alert(e);
                }
            },
            async handleSave(isNewScan) {
                this.$refs.form.validate();
                this.$v.$touch();

              const isScenarioListNotValid = () => {
                for (const action of this.scenarioList) {
                  if(action.type === 'click' && (action.name.length < 1 || action.xpath.length < 1)){
                    return true
                  }
                }
                return false
              }

              const isProxyListNotValid = () => {
                for (const proxy of this.proxy) {
                  if(proxy.region === null || proxy.tool === null){
                    return true
                  }
                }
                return false
              }

              let isValid = true;
              switch (true) {
                case Object.keys(this.url).length === 0 :
                  isValid = false;
                  break;
                case Object.keys(this.consent_type).length === 0 :
                  isValid = false;
                  break;
                case Object.keys(this.page).length === 0 :
                  isValid = false;
                  break;
                case isProxyListNotValid() :
                  isValid = false;
                  break;
                case isScenarioListNotValid() :
                  isValid = false;
                  break;
                default:
                  isValid = true;
                }

                if (!isValid) {
                    this.saveError = true;
                } else {
                    try {
                        let proxies = [];
                        this.proxy.forEach(prx =>{
                            let proxyItem = {};
                            Object.entries(prx).map(([key, value]) => key !== 'isResidentialEnable' ? proxyItem[key] = value : false);
                            proxies.push(proxyItem);
                        });
                        const metaObj = {
                            type: 'meta',
                            website: {name: this.url.name, id: this.url.id},
                            page: this.page,
                            consent_type: this.consent_type,
                            url: this.url.url + this.path,
                            proxies: proxies,
                            default_delay: this.default_delay,
                            scan_frequency: this.scan_frequency
                        };
                        const scenarioRaw = this.scenarioList.map((item) => JSON.stringify(item)).join('\n');
                        let raw = JSON.stringify(metaObj) + "\n" + scenarioRaw;

                        await this.createScenarioScan(
                            Object.assign(
                                {clientName: this.getSelectedClientName},
                                {clientId: this.getSelectedClient},
                                {raw: raw},
                                {id: this.scanId},
                                {isNewScan: isNewScan}
                            )
                        );
                        await this.$router.push(`${SCAN_LIST.path}`);
                    } catch (err) {
                        if(err.response.status === 400){
                            alert(err.response.data.detail);
                        } else {
                            alert(err); // TypeError: failed to fetch
                        }
                    }
                }
            },
            addItem(){
                this.proxy.push({
                    tool: null,
                    region: null,
                    residential: false
                });
            },
            deleteItem(index){
                this.proxy.splice(index, 1);
            },
            setUrl(url){
                this.url = url;
            },
            setPath(path){
                this.path = path;
            },
            setConsentType(consent_type){
                this.consent_type = consent_type;
            },
            setPage(page){
                this.page = page;
            },
            setDefaultDelay(defaultDelay){
                this.default_delay = defaultDelay;
            },
            setScanFrequency(scanFrequency){
                this.scan_frequency = scanFrequency;
            },
            removeScenario(updatedList) {
                this.scenarioList = updatedList;
            },
            addScenario(updatedList) {
                this.scenarioList = updatedList;
            },
            updatedScenario(updatedList) {
                this.scenarioList = updatedList;
            },
            setResidential(index, regionName, toolName) {
                this.getProxyToolsList.forEach(tool=>{
                    if(toolName === tool.name){
                        tool.regions.forEach(region=>{
                            if(region.name === regionName){
                                this.proxy[index].residential = region.residential;
                                this.proxy[index].isResidentialEnable = !(region.datacenter && region.residential)
                            }
                        });
                    }
                })
            },
            onCancel(){
                this.dialog = true
            },
            handleConfirm(answer){
                this.dialog = false;
                if(answer){
                    this.$router.push(`${SCAN_LIST.path}`);
                }
            },
            handleSaveError(){
                this.saveError = false;
            },
            async setEditScanData(scan){
                let proxyTools;
                try {
                    await formApi.proxyTools().then(response =>{ proxyTools = response })
                } catch (err) {
                    alert(err)
                }
                this.scenarioList = [];
                let scanData = scan.split("\n");
                let scanArray = [];
                scanData.forEach(item =>{
                    scanArray.push(JSON.parse(item));

                });
                scanArray.forEach(info=>{
                    if(info.type === 'meta'){
                        this.url = {id: info.website.id, url: (info.url).split('/', 3).join('/'), name: info.website.name};
                        this.path = (info.url).split('/')[3] ? '/' + (info.url).split('/').splice(3).join('/') : '';
                        this.page = {name: info.page.name, id: info.page.id};
                        this.scan_frequency = info.scan_frequency;
                        this.default_delay = info.default_delay;
                        this.consent_type = {name: info.consent_type.name, id:info.consent_type.id};
                        this.proxy = [];
                        info.proxies.forEach(proxyItem=>{
                            let proxyData = proxyItem;
                            proxyTools.forEach(tool=>{
                                if(proxyItem.tool === tool.name){
                                    tool.regions.forEach(region=>{
                                        if(region.name === proxyItem.region){
                                            proxyData.isResidentialEnable = !(region.datacenter && region.residential)
                                        }
                                    });
                                }
                            });
                            this.proxy.push(proxyData)
                        });
                    } else {
                        this.scenarioList.push(info)
                    }
                })
            }
        },
        watch: {
            getSelectedClient: function() {
                if (this.$route.params.scanId) {
                    this.$router.push(`${SCAN_LIST.path}`);
                    return;
                }
                this.loadFormAllSelectBoxData();
            },
            scanId: function(){
                if(this.getScenarioScanData){
                    this.setEditScanData(this.getScenarioScanData);
                }
            },
            getScenarioScanData: function(scan){
                if(scan){
                    this.setEditScanData(scan);
                }
            },
            getWebsitesList: function(list){
                if(this.url.id){
                    let websiteExist = list.some(website => website.id === this.url.id);
                    if(!websiteExist){
                        alert("Scan ID doesn't exist for this selected client or there is an error in this scan");
                        this.$router.push(`${SCAN_LIST.path}`);
                    }
                }
            }
        },
        created() {
            this.loadFormAllSelectBoxData();
        }
    };
</script>
